/** VO usado para chamar o serviço para ordernar a lsita de Pergunta **/
export class Confirmacao {
    public mensagem: string;
    public mostrarOk: boolean;

    constructor(mensagem: string, mostrarOk: boolean) {
      this.mensagem = mensagem;
      this.mostrarOk = mostrarOk;
   }
}
